import { render, staticRenderFns } from "./FaleConosco.vue?vue&type=template&id=0266ce6c&scoped=true"
import script from "./FaleConosco.vue?vue&type=script&lang=js"
export * from "./FaleConosco.vue?vue&type=script&lang=js"
import style0 from "./FaleConosco.vue?vue&type=style&index=0&id=0266ce6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0266ce6c",
  null
  
)

export default component.exports